export const formatEventDate = (
  dateString?: string,
  timeString?: string,
  closingTimeString?: string,
  variant: 'default' | 'compact' | 'mobile-list' = 'default',
  locale = 'ca-ES'
): string => {
  if (!dateString) return '';

  const [day, month, year] = dateString.split('/').map(Number);
  const [hours, minutes] = timeString
    ? timeString.split(':').map(Number)
    : [0, 0];
  const [closingHours, closingMinutes] = closingTimeString
    ? closingTimeString.split(':').map(Number)
    : [null, null];
  const eventDate = new Date(year, month - 1, day, hours, minutes);

  const dayOfWeek = new Intl.DateTimeFormat(locale, {
    weekday: variant === 'compact' ? 'short' : 'long',
  }).format(eventDate);

  const normalizedDayOfWeek =
    dayOfWeek.charAt(0).toUpperCase() + dayOfWeek.slice(1).replace(/\.$/, '');
  const formattedDate = `${normalizedDayOfWeek} ${day
    .toString()
    .padStart(2, '0')}/${month.toString().padStart(2, '0')}`;
  const formattedTime = `${hours.toString().padStart(2, '0')}h${
    minutes > 0 ? minutes.toString().padStart(2, '0') : ''
  }`;

  if (variant === 'mobile-list') {
    return `${formattedDate} - ${formattedTime}`;
  }

  if (closingHours != null && closingMinutes != null) {
    const formattedClosingTime = `${closingHours.toString().padStart(2, '0')}h${
      closingMinutes > 0 ? closingMinutes.toString().padStart(2, '0') : ''
    }`;

    if (variant === 'compact') {
      return `${formattedDate} ${formattedTime}-${formattedClosingTime}`;
    }

    return `${formattedDate} (${formattedTime} a ${formattedClosingTime})`;
  }

  if (variant === 'compact') {
    return `${formattedDate} ${formattedTime}`;
  }

  return `${formattedDate} (${formattedTime})`;
};
